import axios from "axios";
import { getAuthToken, setAuthToken } from "@/lib/api";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// All auth-related calls must include credentials so the httpOnly cookie flows.
// We also attach the Bearer token when present so mobile clients without
// reliable cookie support still authenticate.
export const authApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

authApi.interceptors.request.use((config) => {
  const t = getAuthToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${t}`;
  }
  return config;
});

export const getMe = () => authApi.get("/auth/me").then((r) => r.data);

export const exchangeSession = async (session_id) => {
  const r = await authApi.post("/auth/session", { session_id });
  // Persist the token to localStorage so subsequent requests can authenticate
  // via Authorization: Bearer even if the browser drops the SameSite=None cookie.
  if (r.data?.token) setAuthToken(r.data.token);
  return r.data;
};

export const logoutApi = async () => {
  try {
    await authApi.post("/auth/logout");
  } finally {
    setAuthToken(null);
  }
  return { ok: true };
};
